import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}employees/`;

export default {
  getAll(params = {}) {
    return axios.get(API_URL, { params, headers: buildHeaders() });
  },

  get(id) {
    return axios.get(`${API_URL}${id}`, { headers: buildHeaders() });
  },

  create(data) {
    // FormData -> let axios set boundary (buildHeaders(..., { multipart: true }))
    return axios.post(API_URL, data, {
      headers: buildHeaders({}, { multipart: true }),
    });
  },

  update(id, data) {
    const isFD = typeof FormData !== "undefined" && data instanceof FormData;

    if (isFD) {
      // method spoofing for Laravel so PHP parses multipart body
      if (!data.has("_method")) data.append("_method", "PUT");
      return axios.post(`${API_URL}${id}`, data, {
        headers: buildHeaders({}, { multipart: true }),
      });
    }

    // plain JSON updates (no files) can stay real PUT
    return axios.put(`${API_URL}${id}`, data, { headers: buildHeaders() });
  },

  delete(id) {
    return axios.delete(`${API_URL}${id}`, { headers: buildHeaders() });
  },

  bulkDelete(ids) {
    return axios.post(`${API_URL}bulk-delete`, { ids }, { headers: buildHeaders() });
  },

  bulkSetStatus(ids, status) {
    const payload = { ids, status };
    if (status === "Inactive") {
      payload.reason = "administrative";
    }
    return axios.post(`${API_URL}bulk-set-status`, payload, {
      headers: buildHeaders(),
    });
  },

  assignPermissions(id, permissions) {
    return axios.post(`${API_URL}${id}/assign-permissions`, { permissions }, { headers: buildHeaders() });
  },


   // 🔹 NEW FOR REPORTING
  reportList(params = {}) {
    return axios.get(`${API_URL}report/list`, {
      params,
      headers: buildHeaders(),
    });
  },

  report(params = {}) {
    return axios.get(`${API_URL}report`, {
      params,
      headers: buildHeaders(),
    });
  },

  exportReport(format, params = {}) {
    return axios.get(`${API_URL}report/export`, {
      params: { ...params, format },
      responseType: "blob",
      headers: buildHeaders(),
    });
  },

  orgTree(params = {}) {
    return axios.get(`${API_URL}org-tree`, {
      params,
      headers: buildHeaders(),
    });
  },

  downloadEmailImportTemplate() {
    return axios.get(`${API_URL}import/email-template`, {
      responseType: "blob",
      headers: buildHeaders(),
    });
  },

  previewEmailImport(file) {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API_URL}import/email/preview`, fd, {
      headers: buildHeaders({}, { multipart: true }),
    });
  },

  applyEmailImport(file) {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(`${API_URL}import/email/apply`, fd, {
      headers: buildHeaders({}, { multipart: true }),
    });
  },

  downloadEmployeeImportTemplate() {
    return axios.get(`${API_URL}import/template`, {
      responseType: "blob",
      headers: buildHeaders(),
    });
  },

  previewEmployeeImport(file, mode = "create") {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("mode", mode);
    return axios.post(`${API_URL}import/preview`, fd, {
      headers: buildHeaders({}, { multipart: true }),
    });
  },

  applyEmployeeImport(file, mode = "create") {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("mode", mode);
    return axios.post(`${API_URL}import/apply`, fd, {
      headers: buildHeaders({}, { multipart: true }),
    });
  },

  previewBulkProvisionLogin(ids = [], allReady = false) {
    return axios.post(
      `${API_URL}bulk-provision-login/preview`,
      { ids, all_ready: allReady },
      { headers: buildHeaders() },
    );
  },

  bulkProvisionLogin(ids = [], sendWelcomeEmail = true, allReady = false) {
    return axios.post(
      `${API_URL}bulk-provision-login`,
      {
        ids,
        send_welcome_email: sendWelcomeEmail,
        all_ready: allReady,
      },
      { headers: buildHeaders() },
    );
  },

  resendSetPasswordEmail(employeeId) {
    return axios.post(
      `${API_URL}${employeeId}/resend-set-password`,
      {},
      { headers: buildHeaders() },
    );
  },

  listGratuities(employeeId) {
    return axios.get(`${API_URL}${employeeId}/gratuities`, {
      headers: buildHeaders(),
    });
  },

  previewGratuity(employeeId, payload) {
    return axios.post(`${API_URL}${employeeId}/gratuities/preview`, payload, {
      headers: buildHeaders(),
    });
  },

  scheduleGratuity(employeeId, payload) {
    return axios.post(`${API_URL}${employeeId}/gratuities`, payload, {
      headers: buildHeaders(),
    });
  },

  cancelGratuity(employeeId, gratuityId) {
    return axios.delete(`${API_URL}${employeeId}/gratuities/${gratuityId}`, {
      headers: buildHeaders(),
    });
  },
};
